import React from 'react';
import { Quote } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    quote: "Sapis Capital's strategic guidance and operational support were instrumental in helping us scale our business internationally. Their team's hands-on approach and deep industry knowledge made them invaluable partners.",
    author: 'Sarah Johnson',
    title: 'CEO, NexGen Technologies'
  }, {
    quote: 'Beyond just capital, Sapis brought a level of expertise and connections that transformed our growth trajectory. They truly understand the challenges of scaling a business and provide solutions that work.',
    author: 'Michael Chen',
    title: 'Founder, DataSphere'
  }, {
    quote: 'Working with Sapis Capital has been a game-changer for our company. Their patient capital approach and focus on sustainable growth aligned perfectly with our vision for the business.',
    author: 'Robert Keller',
    title: 'President, FinCore Systems'
  }];
  const partners = ['https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80', 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80', 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80', 'https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'];
  return <section id="testimonials" className="py-20 bg-white" data-id="element-212">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-215">
            What Our Partners Say
          </h2>
          <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-216"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-217">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-sm relative" data-id="element-218">
              <Quote className="absolute top-6 left-6 text-gray-200" size={40} data-id="element-219" />
              <div className="relative" data-id="element-220">
                <p className="text-gray-600 italic mb-6 leading-relaxed" data-id="element-221">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-222">
                  <p className="font-semibold text-[#0a2351]" data-id="element-223">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-224">{testimonial.title}</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-225">
          <h3 className="text-2xl font-semibold mb-8 text-[#0a2351]" data-id="element-226">
            Our Strategic Partners
          </h3>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-12" data-id="element-227">
          {partners.map((partner, index) => <div key={index} className="grayscale hover:grayscale-0 transition-all duration-300" data-id="element-228">
              <img src={partner} alt={`Strategic partner ${index + 1}`} className="h-16 object-contain" data-id="element-229" />
            </div>)}
        </div>
      </div>
    </section>;
};